import React, { memo } from 'react';

const CustomBadge = ({
  id = null,
  label = '',
  style = {},
  className = '',
  color = '',
  title = label,
  onClick,
  children,
  ...rest
}) => {
  const addclass = `${className} badge ${color ? `badge-${color}` : ''} ${onClick ? 'clickable' : ''}`;

  let labelName = label;
  if (label === null || label === undefined) {
    labelName = '';
  }
  labelName = labelName.toString();

  return (
    <span id={id} className={addclass} title={title} onClick={onClick} style={style} {...rest}>
      {labelName || children}
    </span>
  );
};

CustomBadge.displayName = 'CustomBadge';
export default memo(CustomBadge);
